// extracted by mini-css-extract-plugin
export var measureBox = "_dd-0";